
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.265 15.959c-.398-4.412-2.598-6.626-2.598-6.626l-4-5.333H9.334l-4 5.333s-.946.956-1.712 2.85a3.322 3.322 0 00-2.288 3.15c0 .966.416 1.828 1.072 2.437-.25.468-.406.995-.406 1.563 0 1.306.757 2.424 1.85 2.971C4.705 23.585 5.848 24 6.667 24h10.666c.92 0 2.25-.52 3.12-2.207a3.323 3.323 0 002.214-3.126 3.325 3.325 0 00-1.402-2.708zM12 4c.367 0 .706-.105 1-.277.296.172.634.277 1 .277 1.105 0 2.667-1.563 2.667-2.667 0 0 0-1.333-1.334-1.333-.525 0-.666.667-1.333.667-.666 0-.666-.667-2-.667-1.333 0-1.333.667-2 .667C9.334.667 9.193 0 8.667 0 7.334 0 7.334 1.333 7.334 1.333 7.333 2.437 8.896 4 10 4c.366 0 .705-.105 1-.277.296.172.634.277 1 .277z","fill":"#FDD888"}}),_c('path',{attrs:{"d":"M16 4a.666.666 0 01-.667.667H8.667a.667.667 0 010-1.333h6.666c.369 0 .667.298.667.666z","fill":"#BF6952"}}),_c('path',{attrs:{"d":"M15.934 16.361c0-2.984-5.72-2.79-5.72-4.59 0-.872.867-1.298 1.873-1.298 1.693 0 1.994 1.046 2.76 1.046.542 0 .803-.329.803-.697 0-.856-1.35-1.504-2.643-1.728v-.827c0-.515-.434-.933-.97-.933s-.97.418-.97.933v.855c-1.41.309-2.625 1.25-2.625 2.784 0 2.866 5.72 2.75 5.72 4.763 0 .698-.786 1.396-2.075 1.396-1.934 0-2.577-1.26-3.363-1.26-.382 0-.724.31-.724.776 0 .742 1.292 1.634 3.068 1.883V20.403c0 .515.434.933.97.933s.97-.418.97-.933v-.932c0-.012-.005-.02-.006-.03 1.599-.287 2.932-1.288 2.932-3.08z","fill":"#67757F"}})])
          )
        }
      }
    